import { BookCheck, Clock, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { TrainingProgress } from '@/hooks/use-training-progress';

import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { formatMinutes } from '@/lib/format';


interface QuickStatsRowProps {
  progress: TrainingProgress | undefined;
}

export function QuickStatsRow({ progress }: QuickStatsRowProps) {
  const completed = progress?.completed_modules ?? 0;
  const total = progress?.total_modules ?? 6;
  const completedMinutes = progress?.completed_minutes ?? 0;
  const allDone = completed === total;

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <Card>
        <CardContent className="flex items-center gap-4 p-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <BookCheck className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">Modules Completed</p>
            <p className="text-lg font-semibold">
              {completed}/{total}
            </p>
            <Progress value={(completed / total) * 100} className="mt-1 h-2" aria-label={`${completed} of ${total} modules completed`} />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center gap-4 p-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Clock className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Time Invested</p>
            <p className="text-lg font-semibold">{formatMinutes(completedMinutes)}</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center gap-4 p-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Award className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Certificate</p>
            {allDone ? (
              <Link
                to="/progress"
                className="text-lg font-semibold text-primary hover:underline"
              >
                Earned
              </Link>
            ) : (
              <p className="text-sm text-muted-foreground">Complete all modules to earn</p>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
